<template>
  <common-modal
    :name="name"
    :title="title"
    :hideFooter="true"
    :onClosed="handleClose"
    height="auto"
    :width="generateWidth"
  >
    <template #modal-body>
      <div>
        <slot name="template-desc"></slot>
        <validation-form @on-submit="saveParameters">
          <div
            class="md-layout items-center mt-5"
            v-for="(parameter, index) in parameters"
            :key="parameter + index"
          >
            <div
              class="md-layout-item md-size-80 md-xsmall-size-100 md-layout px-0"
            >
              <div class="md-layout-item md-size-50 md-xsmall-size-100">
                <validation-field :validations="validations.name" name="name">
                  <label>{{ $t("class.category_name") }}</label>
                  <md-input v-model="parameter.name"></md-input>
                </validation-field>
              </div>

              <div class="md-layout-item md-size-50 md-xsmall-size-100">
                <validation-field
                  :validations="validations.weight"
                  name="weight"
                >
                  <label>{{ $t("class.will_calculate_as") }}</label>
                  <md-input v-model="parameter.weight"></md-input>
                  <span class="md-suffix">%</span>
                </validation-field>
              </div>
            </div>

            <div
              class="actions md-layout-item md-size-20"
              v-if="isAbleToDelete && !viewByStudent"
            >
              <md-button
                class="md-simple md-just-icon md-icon-button md-danger"
                @click.native="() => deleteParameter(index)"
              >
                <md-icon :style="{ fontSize: '30px !important' }">
                  delete_forever
                </md-icon>
              </md-button>
            </div>
          </div>
          <md-button
            v-if="!isDisableAction && !viewByStudent"
            class="md-success"
            @click.native="addParameter"
          >
            <i class="fas fa-plus text-sm"></i> {{ $t("common.add") }}
          </md-button>
          <div
            class="md-layout md-gutter pt-4 text-center text-red-500 font-bold text-sm"
            v-if="!parameters.length"
          >
            {{ $t("class.you_must_set_at_least_1_type_in_the_parameter") }}
          </div>
          <div
            class="md-layout md-gutter pt-4 text-center text-red-500 font-bold text-sm"
            v-if="errorMsg"
          >
            {{ errorMsg }}
          </div>
          <div
            class="form-actions text-right"
            v-if="!isDisableAction && !viewByStudent"
          >
            <md-button class="md-raised" @click="handleClose">{{
              $t("common.cancel")
            }}</md-button>
            <md-button type="submit" class="md-success ml-4">{{
              $t("common.save")
            }}</md-button>
          </div>
        </validation-form>
      </div>
    </template>
  </common-modal>
</template>

<script>
import CommonModal from "@/components/Base/CommonModal";
import { service_paths, service_names } from "@/constants/Services";
import { parameterValidations } from "@/validations/classes";
import cloneDeep from "lodash/cloneDeep";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";
import { mapGetters } from "vuex";
import { Message, getId } from "@/helpers/utils";
export default {
  components: { CommonModal },
  props: ["name", "title", "isDisableAction", "scoreData"],
  inject: ["getScores"],
  data() {
    const classId = this.$route.params.id;
    return {
      path: `${service_paths.class_activity_categories}/class/${classId}`,
      parameters: [],
      parametersTemp: [],
      validations: parameterValidations,
      errorMsg: null,
      Role,
      hasValidRole,
      generateWidth: null,
      hasScoreList: false
    };
  },
  computed: {
    ...mapGetters("user", ["role"]),
    isAbleToDelete() {
      return this.parameters.length > 1;
    },
    viewByStudent() {
      return hasValidRole(this.role, [Role.Student, Role.Family]);
    }
  },
  watch: {
    scoreData: function(newVal) {
      this.hasScoreList = newVal?.score_lists[0]?.categories?.some(
        item => item.activities.length
      );
    }
  },
  created() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    this.getParameters();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.generateWidth = window.innerWidth < 959 ? "95%" : "800px";
    },
    getParameters() {
      return this.$axios.get(this.path).then(response => {
        if (response.data) {
          this.parameters = response.data;
          this.parametersTemp = cloneDeep(response.data);
        }
      });
    },
    addParameter() {
      this.parameters.push({ name: "", weight: "" });
    },
    deleteParameter(index) {
      this.parameters.splice(index, 1);
    },
    saveParameters() {
      const reducer = (previousValue, currentValue) =>
        +previousValue + +currentValue.weight;
      const sum = this.parameters.reduce(reducer, 0);
      if (sum > 100) {
        this.errorMsg = this.$t("class.total_weight_not_be_more_than_100");
        return;
      }
      this.errorMsg = null;
      let path;
      const classId = this.$route.params.id;
      if (this.hasScoreList) {
        path = `${service_names.school}/class-activities/sis/setup-parameter/class/${classId}`;
      } else {
        path = `${service_paths.class_activity_categories}/class/${classId}`;
      }
      const parameters = this.parameters.map(item => {
        return {
          name: item.name,
          id: getId(item),
          weight: item.weight
        };
      });
      this.$axios.post(path, parameters).then(() => {
        Message.success(this.$t("common.success"));
        this.$modal.hide(this.name);
        this.getScores();
        this.getParameters();
      });
    },

    handleClose() {
      this.$modal.hide(this.name);
      this.parameters = cloneDeep(this.parametersTemp);
    }
  }
};
</script>

<style lang="scss"></style>
